import { supportedLocales, defaultLocale, type Locale } from './locales';

const COOKIE_NAME = 'site_locale';
const NEXT_INTL_LOCALE_COOKIE = 'NEXT_LOCALE';
const COOKIE_MAX_AGE_DAYS = 365;
const LOCALES_SET = new Set<string>(supportedLocales);

export function setLocaleCookie(locale: Locale) {
  const maxAge = 60 * 60 * 24 * COOKIE_MAX_AGE_DAYS;
  const opts = `path=/; max-age=${maxAge}; SameSite=Lax`;
  if (typeof document !== 'undefined') {
    document.cookie = `${COOKIE_NAME}=${locale}; ${opts}`;
    document.cookie = `${NEXT_INTL_LOCALE_COOKIE}=${locale}; ${opts}`;
  }
}

export function pathnameWithLocale(fullPathname: string, newLocale: Locale): string {
  const segments = fullPathname.split('/').filter(Boolean);
  const hasLocaleSegment = segments.length > 0 && LOCALES_SET.has(segments[0]);
  const pathWithoutLocale = hasLocaleSegment
    ? '/' + segments.slice(1).join('/')
    : fullPathname || '/';
  const basePath = pathWithoutLocale === '/' ? '' : pathWithoutLocale;

  if (newLocale === defaultLocale) {
    return basePath || '/';
  }
  return basePath ? `/${newLocale}${basePath}` : `/${newLocale}`;
}

export function buildLocaleSwitchUrl(currentPathname: string, newLocale: Locale): string {
  const newPath = pathnameWithLocale(currentPathname, newLocale);
  if (typeof window !== 'undefined' && window.location.search) {
    return `${newPath}${window.location.search}`;
  }
  return newPath;
}
